import React, { createContext, useCallback, useEffect, useState } from 'react';
import MoveTo from 'moveto';
import NavbarShopFilter from '../containers/navbar-shop-filter';
import ShopRegionAll from '../containers/shop-region-all';
import ShopLeadbox from '../containers/shop-leadbox';
import { openMain } from '@ts/modules/open-main';
/**
 * コンテクスト
 */
// ゴージャスグッズキャラバンの選択フラグ
export const SpecialStatusContext = createContext(false);
const ShopItemsRoot = ({ shopItems, shopItemsOrder }) => {
    const moveTo = new MoveTo();
    // 選択中リージョンID、初期値は全表示
    const [regionID, setRegionID] = useState('0');
    const [regionName, setRegionName] = useState('');
    // ゴージャスグッズキャラバンの選択状態を代入する
    const [specialStatus, setSpecialStatus] = useState(false);
    /**
     * 地域ボタンのクリック
     */
    const handleSelectFilter = useCallback((regionID, regionName) => {
        setRegionID(regionID);
        setRegionName(regionName);
    }, [
        shopItemsOrder
    ]);
    /**
     * ページ内リンクへの移動
     */
    useEffect(() => {
        if (location.hash === '') {
            // ページの目隠しをはずす
            window.addEventListener('load', () => openMain('.main'));
            return;
        }
        const scrollTargetEl = document.querySelector(location.hash);
        if (scrollTargetEl === null) {
            window.addEventListener('load', () => openMain('.main'));
            return;
        }
        // ページ内リンクの処理
        window.addEventListener('load', () => {
            // ページ内リンクへの移動がある場合は、キャンペーン絞り込みを行っているとみなす
            setSpecialStatus(true);
            moveTo.move(scrollTargetEl);
            // ページの目隠しをはずす
            openMain('.main');
        });
    }, []);
    /**
     * リージョン切り替えの発生
     */
    useEffect(() => {
        // ゴージャスグッズキャラバンが選択された場合は真に
        setSpecialStatus(regionID === '0' && regionName !== '');
    }, [
        regionID,
        regionName
    ]);
    return (React.createElement(SpecialStatusContext.Provider, { value: specialStatus },
        React.createElement("div", null,
            React.createElement(NavbarShopFilter, { shopItemsOrder: shopItemsOrder, onSelectFilter: handleSelectFilter }),
            React.createElement("div", { className: "pt-10" },
                React.createElement("div", { className: "content" },
                    React.createElement(ShopLeadbox, null),
                    React.createElement(ShopRegionAll, { shopItems: shopItems, shopItemsOrder: shopItemsOrder, regionID: regionID }))))));
};
export default ShopItemsRoot;
